import PropTypes from "prop-types"
import React, { useEffect, useCallback, useRef, useState } from "react"

// Import Scrollbar
import SimpleBar from "simplebar-react"

// MetisMenu
import MetisMenu from "metismenujs"
import withRouter from "components/Common/withRouter"
import { Link, useLocation, useNavigate } from "react-router-dom"

// i18n
import { withTranslation } from "react-i18next"
import { useDispatch, useSelector } from "react-redux"
import { getPvsDetails } from "../../redux/actions/pvs"
import { GET_PVS_DETAILS_RESET } from "../../redux/types/pvs"
import ConfirmPopup from "components/ConfirmPopup"

const SidebarContent = props => {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const location = useLocation()
  const ref = useRef()
  const path = location.pathname

  const [selectedPVSEntry, setSelectedPVSEntry] = useState(null)
  const [isLogoutConfirmOpen, setIsLogoutConfirmOpen] = useState(false)

  const activateParentDropdown = useCallback(item => {
    // Add active class to the clicked link
    item.classList.add("active")

    let element = item.parentElement

    // Traverse up the DOM tree
    while (element) {
      if (element.tagName === "LI") {
        element.classList.add("mm-active")
      }
      if (element.tagName === "UL" && element.classList.contains("sub-menu")) {
        element.classList.add("mm-show")
      }
      // Stop at side-menu
      if (element.id === "side-menu") {
        break
      }
      element = element.parentElement
    }

    scrollElement(item)
    return false
  }, [])

  const removeActivation = items => {
    for (var i = 0; i < items.length; ++i) {
      var item = items[i]
      const parent = items[i].parentElement

      if (item && item.classList.contains("active")) {
        item.classList.remove("active")
      }
      if (parent) {
        const parent2El =
          parent.childNodes && parent.childNodes.length && parent.childNodes[1]
            ? parent.childNodes[1]
            : null
        if (parent2El && parent2El.id !== "side-menu") {
          parent2El.classList.remove("mm-show")
        }

        parent.classList.remove("mm-active")
        const parent2 = parent.parentElement

        if (parent2) {
          parent2.classList.remove("mm-show")

          const parent3 = parent2.parentElement
          if (parent3) {
            parent3.classList.remove("mm-active")
            parent3.childNodes[0].classList.remove("mm-active")

            const parent4 = parent3.parentElement
            if (parent4) {
              parent4.classList.remove("mm-show")
              const parent5 = parent4.parentElement
              if (parent5) {
                parent5.classList.remove("mm-show")
                parent5.childNodes[0].classList.remove("mm-active")
              }
            }
          }
        }
      }
    }
  }

  const activeMenu = useCallback(() => {
    const pathName = location.pathname
    const fullPath = pathName

    let matchingMenuItem = null
    const ul = document.getElementById("side-menu")
    const items = ul.getElementsByTagName("a")
    removeActivation(items)

    for (let i = 0; i < items.length; ++i) {
      if (fullPath === items[i].pathname) {
        matchingMenuItem = items[i]
        break
      }
    }
    if (matchingMenuItem) {
      activateParentDropdown(matchingMenuItem)
    }
  }, [path, activateParentDropdown])

  useEffect(() => {
    ref.current.recalculate()
  }, [])

  useEffect(() => {
    new MetisMenu("#side-menu")
    activeMenu()
  }, [])

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" })
    activeMenu()
  }, [activeMenu])

  function scrollElement(item) {
    if (item) {
      const currentPosition = item.offsetTop
      if (currentPosition > window.innerHeight) {
        ref.current.getScrollElement().scrollTop = currentPosition - 300
      }
    }
  }
  const closeSidebarOnMobile = () => {
    if (window.innerWidth <= 991) {
      document.body.classList.remove("sidebar-enable")
    }
  }

  const openLogoutConfirm = event => {
    if (event && event.preventDefault) {
      event.preventDefault()
    }
    closeSidebarOnMobile()
    setIsLogoutConfirmOpen(true)
  }
  useEffect(() => {
    const sidebar = document.getElementById("side-menu")
    const handleClick = e => {
      const target = e.target.closest("a")
      if (target && !target.classList.contains("has-arrow")) {
        closeSidebarOnMobile()
      }
    }
    sidebar.addEventListener("click", handleClick)

    return () => {
      sidebar.removeEventListener("click", handleClick)
    }
  }, [location.pathname])

  const user = useSelector(state => state.auth.user)

  return (
    <React.Fragment>
      <SimpleBar style={{ maxHeight: "100%" }} ref={ref}>
        <div id="sidebar-menu">
          <ul className="metismenu list-unstyled" id="side-menu">
            {/* -------------------- ADMIN -------------------- */}
            {user && user.user_type === "admin" && (
              <>
                <li className="menu-title">{props.t("Main")} </li>
                <li>
                  <Link to="/dashboard" className="waves-effect">
                    <i className="ti-home"></i>
                    {/* <span className="badge rounded-pill bg-primary float-end">
                      1
                    </span> */}
                    <span>{props.t("Dashboard")}</span>
                  </Link>
                </li>

                <li>
                  <Link to="/#" className="has-arrow waves-effect">
                    <i className="ti-view-grid"></i>
                    <span>{props.t("Reports")}</span>
                  </Link>
                  <ul className="sub-menu" aria-expanded="false">
                    <li>
                      <Link to="/all-invoices">{props.t("Invoices")}</Link>
                    </li>
                  </ul>
                </li>

                <li>
                  <Link to="/#" className="has-arrow waves-effect">
                    <i className="ti-receipt"></i>
                    <span>{props.t("PVS")}</span>
                  </Link>
                  <ul className="sub-menu" aria-expanded="false">
                    <li>
                      <Link to="/pvs">{props.t("PVS Members")}</Link>
                    </li>
                    <li>
                      <Link to="/paid-pvs">{props.t("Pending Approval")}</Link>
                    </li>
                    <li>
                      <Link to="/pvs-clarification">
                        {props.t("Clarification")}
                      </Link>
                    </li>
                    <li>
                      <Link to="/pvs-brand">{props.t("Brand Wise List")}</Link>
                    </li>
                    <li>
                      <Link to="/rejected-pvs">
                        {props.t("Rejected Applications")}
                      </Link>
                    </li>
                    <li>
                      <Link to="/pending-pvs">
                        {props.t("Draft Applications")}
                      </Link>
                    </li>
                  </ul>
                </li>

                <li>
                  <Link to="/#" className="has-arrow waves-effect">
                    <i className="ti-shopping-cart"></i>
                    <span>{props.t("Bazaar")}</span>
                  </Link>
                  <ul className="sub-menu" aria-expanded="false">
                    <li>
                      <Link to="/all-bazaar-list" className="waves-effect">
                        <span>{props.t("PULA Bazaar")}</span>
                      </Link>
                    </li>
                    <li>
                      <Link to="/bazaar-interest-list">
                        {props.t("Interest List")}
                      </Link>
                    </li>
                  </ul>
                </li>

                <li>
                  <Link to="/#" className="has-arrow waves-effect">
                    <i className="ti-view-grid"></i>
                    <span>{props.t("Events")}</span>
                  </Link>
                  <ul className="sub-menu" aria-expanded="false">
                    <li>
                      <Link to="/events/upcoming-list">
                        {props.t("Upcoming Events")}
                      </Link>
                    </li>
                    <li>
                      <Link to="/events/past-list">
                        {props.t("Past Events")}
                      </Link>
                    </li>
                    <li>
                      <Link to="/events/category-list">
                        {props.t("Category")}
                      </Link>
                    </li>
                  </ul>
                </li>

                <li>
                  <Link to="/awards-list" className="waves-effect">
                    <i className="ti-cup"></i>
                    <span>{props.t("PULA Awards")}</span>
                  </Link>
                </li>

                <li>
                  <Link to="/users" className="waves-effect">
                    <i className="ti-user"></i>
                    <span>{props.t("All Users")}</span>
                  </Link>
                </li>

                <li>
                  <Link to="/#" className="has-arrow waves-effect">
                    <i className="ti-receipt"></i>
                    <span>{props.t("Category & Products")}</span>
                  </Link>
                  <ul className="sub-menu" aria-expanded="false">
                    <li>
                      <Link to="/pvs-category">{props.t("Category")}</Link>
                    </li>
                    <li>
                      <Link to="/pvs-subcategory">
                        {props.t("Sub Category")}
                      </Link>
                    </li>
                    <li>
                      <Link to="/product-list">{props.t("Products")}</Link>
                    </li>
                    <li>
                      <Link to="/pvs-keywords">{props.t("Keywords")}</Link>
                    </li>
                  </ul>
                </li>

                <li>
                  <Link to="/#" className="has-arrow waves-effect">
                    <i className="ti-package"></i>
                    <span>{props.t("Form Users")}</span>
                  </Link>
                  <ul className="sub-menu" aria-expanded="false">
                    <li>
                      <Link to="/awards-list">{props.t("Awards")}</Link>
                    </li>
                    <li>
                      <Link to="/lucky-draw-user">
                        {props.t("Lucky Draw Users")}
                      </Link>
                    </li>
                  </ul>
                </li>

                <li className="menu-title">{props.t("Account")} </li>
                <li>
                  <Link
                    to="/logout"
                    className="waves-effect"
                    onClick={openLogoutConfirm}
                  >
                    <i className="dripicons-exit"></i>
                    <span>{props.t("Logout")}</span>
                  </Link>
                </li>
              </>
            )}

            {/* -------------------- STAFF -------------------- */}
            {user && user.user_type === "staff" && (
              <>
                <li>
                  <Link to="/#" className="has-arrow waves-effect">
                    <i className="ti-receipt"></i>
                    <span>{props.t("PVS")}</span>
                  </Link>
                  <ul className="sub-menu" aria-expanded="false">
                    <li>
                      <Link to="/pvs">{props.t("PVS Members")}</Link>
                    </li>
                    <li>
                      <Link to="/paid-pvs">{props.t("Pending Approval")}</Link>
                    </li>
                    <li>
                      <Link to="/pvs-clarification">
                        {props.t("Clarification")}
                      </Link>
                    </li>
                    <li>
                      <Link to="/pvs-brand">{props.t("Brand Wise List")}</Link>
                    </li>
                    <li>
                      <Link to="/rejected-pvs">
                        {props.t("Rejected Applications")}
                      </Link>
                    </li>
                    <li>
                      <Link to="/pending-pvs">
                        {props.t("Draft Applications")}
                      </Link>
                    </li>
                  </ul>
                </li>
                <li className="menu-title">{props.t("Account")} </li>
                <li>
                  <Link
                    to="/logout"
                    className="waves-effect"
                    onClick={openLogoutConfirm}
                  >
                    <i className="dripicons-exit"></i>
                    <span>{props.t("Logout")}</span>
                  </Link>
                </li>
              </>
            )}

            {/* -------------------- NORMAL USER -------------------- */}
            {user && user.user_type === "user" && (
              <>
                <li className="menu-title">{props.t("Main")} </li>
                <li>
                  <Link to="/home" className="waves-effect">
                    <i className="ti-home"></i>
                    <span>{props.t("Dashboard")}</span>
                  </Link>
                </li>
                <li>
                  <Link to="/pvs-info" className="waves-effect">
                    <i className="ti-check-box"></i>
                    <span>{props.t("PULA Verified Seller")}</span>
                  </Link>
                </li>
                <li>
                  <Link to="/bazaar-info" className="waves-effect">
                    <i className="ti-shopping-cart"></i>
                    <span>{props.t("PULA Bazaar")}</span>
                  </Link>
                </li>
                <li>
                  <Link to="/awards-info" className="waves-effect">
                    <i className="ti-cup"></i>
                    <span>{props.t("PULA Awards")}</span>
                  </Link>
                </li>
                <li>
                  <Link to="/events-info" className="waves-effect">
                    <i className="mdi mdi-ticket-outline"></i>
                    <span>{props.t("PULA Events")}</span>
                  </Link>
                </li>
                <li className="menu-title">{props.t("Account")} </li>
                <li>
                  <Link to="/user-profile" className="waves-effect">
                    <i className="ti-user"></i>
                    <span>{props.t("My Profile")}</span>
                  </Link>
                </li>
                <li>
                  <Link
                    to="/logout"
                    className="waves-effect"
                    onClick={openLogoutConfirm}
                  >
                    <i className="dripicons-exit"></i>
                    <span>{props.t("Logout")}</span>
                  </Link>
                </li>
              </>
            )}
          </ul>
        </div>
      </SimpleBar>
      <ConfirmPopup
        title="Logout"
        isOpen={isLogoutConfirmOpen}
        message="Are you sure you want to logout?"
        onConfirm={() => {
          setIsLogoutConfirmOpen(false)
          navigate("/logout", { replace: true })
        }}
        confirmText="Logout"
        cancelText="Cancel"
        toggle={() => setIsLogoutConfirmOpen(!isLogoutConfirmOpen)}
      />
    </React.Fragment>
  )
}

SidebarContent.propTypes = {
  location: PropTypes.object,
  t: PropTypes.any,
}

export default withRouter(withTranslation()(SidebarContent))
